module.exports = __webpack_public_path__ + "img/stepBoardApproval.62e65654.png";